// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-dashboard {
  background-color: #f8fafb;
  height: 100%;
}

.user-dashboard .sidebar {
  top: 0;
  padding: 0;
  width: 16%;
}

.user-dashboard .logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.user-account {
  padding: 15px;
  border-bottom: 1px solid #e5e4e4;
  opacity: 1;
}

.user-dashboard .user-card {
  background: #f8fafb 0% 0% no-repeat padding-box;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  opacity: 1;
  padding: 5px;
}

.user-dashboard .user-profile {
  display: flex;
  gap: 5px;
  color: #a0a0a0;
}

.user-profile .about-user {
  padding-top: 4px;
  font-size: 10px;
}

.user-profile .about-user h1 {
  font-weight: 600;
  color: #000000;
  font-size: 12px;
  margin-bottom: 0;
}

.user-profile .about-user p {
  font-weight: 100;
  margin-bottom: 4px;
}

.user-profile .about-user span {
  margin-left: 5px;
  color: #3383f4;
}

.user-dashboard .user-card {
  margin-top: 10px;
}

.user-card p {
  color: #a0a0a0;
  font-size: 10px;
  margin-bottom: 0;
}

.user-card span {
  font-size: 14px;
  letter-spacing: 3.5px;
  color: #000000;
  margin-left: 4px;
  font-weight: 500;
}

.user-profile .avatar {
  height: 35px;
  width: 35px;
  border-radius: 50%;
}

.user-dashboard .tier {
  margin-top: 10px;
}

.user-dashboard h2 {
  font-size: 10px;
  color: #000000;
  letter-spacing: 0.63px;
  margin-bottom: 4px;
}

.user-dashboard h3 {
  letter-spacing: 0.63px;
  color: #838383;
  font-size: 10px;
}

.user-dashboard .progress {
  height: 6px;
}

.user-dashboard .progress-bar {
  border-radius: 5px;
}

.user-dashboard .balance {
  margin-top: 18px;
}

.user-dashboard .balance h3 {
  color: #a0a0a0;
  margin-bottom: 0;
}

.user-dashboard .balance p {
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 3.5px;
}

/* .user-dashboard .nav {
  padding-bottom: 30px;
  border-bottom: 1px solid #060d27;
} */

.nav-links {
  padding: 25px 15px;
}

.nav-link img {
  height: 15px;
  width: 15px;
}

.user-dashboard .nav-item {
  padding: 7px 0;
  cursor: pointer;
  border-bottom: 1px solid #e5e4e4;
}

.user-dashboard .active {
  background-color: #e8edff;
  border-right: 3px solid #060d27;
}

.user-dashboard .nav-link {
  letter-spacing: 1px;
  color: #a0a0a0;
  margin-left: 10px;
}

.user-dashboard .active-link {
  color: #000000;
  font-weight: 500;
}

.user-dashboard .sign-out {
  margin-top: 20px;
}

.sign-out a {
  color: #b1580b;
  font-size: 12px;
  font-weight: 100;
  text-decoration: none;
}

.sign-out img {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}

.user-dashboard .btn {
  box-shadow: none;
}

.user-dashboard main {
  margin-left: 16.3%;
  padding: 15px;
}

.user-dashboard .wallet-summary {
  background-color: #060d27;
  border-radius: 15px;
  padding: 25px 15px;
}

.user-dashboard .wallet-summary .btn {
  background-color: #242e4a;
  color: #ffffff;
  width: 100%;
  padding: 10px;
  border: none;
  letter-spacing: 1.13px;
}

.user-dashboard .wallet-summary .hide-data {
  display: flex;
  justify-content: flex-end;
}

.user-dashboard .wallet-summary .hide-data img {
  height: 15px;
}

.user-dashboard .wallet-summary .hide-data {
  cursor: pointer;
}

.user-dashboard .wallet-summary span {
  font-size: 14px;
  letter-spacing: 3.5px;
  color: #bccfff;
  margin-left: 4px;
  font-weight: 500;
}

.active-icon {
  filter: brightness(0.1);
}

.user-dashboard .wallet-summary p {
  font-size: 10px;
  letter-spacing: 0.81px;
  color: #b4b4b4;
}

.user-dashboard .available-balance h1 {
  font-size: 10px;
  letter-spacing: 0.81px;
  color: #b4b4b4;
  margin-bottom: 12px;
}

.user-dashboard .available-balance p {
  letter-spacing: 0px;
  color: #ffffff;
  font-family: "OCR";
  font-size: 20px;
  margin-bottom: 8px;
}

.user-dashboard .available-balance sup {
  top: -1.5em;
  font-size: 14px;
}

.user-dashboard .vas-services {
  cursor: pointer;
}

.user-dashboard .bill-payment {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 15px;
  padding: 12px;
  height: 95px;
  /* width: 270px; */
}

.user-dashboard .bill-payment img {
  height: 45px;
  width: 45px;
}

.user-dashboard .bill-payment h1 {
  font-size: 16px;
  color: #586684;
}

.user-dashboard .bill-payment p {
  margin-bottom: 0;
  font-size: 8px;
  color: #a0a0a0;
  text-transform: uppercase;
}

.bill-payment .arrow {
  height: 10px !important;
}

.bill-payment .services {
  margin-right: auto;
  margin-left: 6px;
}

.become-an-agent {
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 40px;
  height: 100px;
  background-color: #faf1d6;
  border-radius: 15px;
}

.become-an-agent .text {
  margin-right: auto;
  position: relative;
}

.become-an-agent .text h4 {
  margin-right: auto;
  font-size: 28px;
  font-weight: 600;
  color: #3358a9;
}

.become-an-agent .text .desc {
  position: absolute;
  color: #eebd46;
  top: 30px;
  left: 90px;
  width: 250px;
  font-weight: 500;
}

.become-an-agent .spout-logo {
  height: 60px;
}

.become-an-agent .display-image {
  position: absolute;
  right: 15%;
  top: 5px;
}

.become-an-agent .display-image img {
  height: 130px;
}

.user-dashboard .table-heading {
  display: flex;
}

.user-dashboard .table-heading h5 {
  margin-right: auto;
  font-size: 16px;
  letter-spacing: 6px;
  color: #060d27;
  margin-bottom: 15px;
}

.user-dashboard .table-heading a {
  letter-spacing: 0.72px;
  color: #3383f4;
  font-weight: 100;
  text-decoration: none;
  font-size: 12px;
}

.user-dashboard .table-responsive {
  background-color: #ffffff;
}

.user-dashboard .services h6 {
  color: #a7a7a7;
  font-size: 12px;
  font-weight: 100;
}

.user-dashboard .service-form {
  border-right: 1px solid #a7a7a7;
  border-left: 2px solid #a7a7a7;
  padding-inline: 15px;
  padding-bottom: 40px;
}

.user-dashboard .service-type ul {
  list-style: none;
  margin-top: 30px;
  padding: 0;
  color: #a0a0a0;
  font-size: 12px;
}

.user-dashboard .icon-service {
  height: 25px;
  width: 25px;
  margin-right: 10px;
}

.user-dashboard .service-type li {
  margin-bottom: 10px;
  cursor: pointer;
}

.service-type .active-service {
  color: #2300e5;
}

.user-dashboard .service-form form {
  margin-top: 30px;
  padding-right: 30px;
}

.services .disabled {
  pointer-events: none;
  opacity: 0.7;
}

.service-form .grouped-input {
  position: relative;
  /* background-color: transparent; */
  border-radius: 4px;
  padding: 2px 8px;
  margin-bottom: 20px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: 100;
}

.service-form .default {
  border: 1px solid #097ffa;
}

.service-form .error {
  border: 1px solid #e86880;
}
.service-form label {
  position: absolute;
}

.service-form .form-control {
  border: none;
  height: 36px;
  background-color: transparent;
  box-shadow: none;
  padding: 0;
  padding-top: 14px;
  font-weight: 500;
  color: #000000;
  text-transform: uppercase;
}

.service-form .continue {
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-form .btn {
  background-color: #4d68c9;
  border: none;
  border-radius: 4px;
  padding-inline: 40px;
}

.service-form .select-icon {
  display: flex;
  gap: 5px;
  position: absolute;
  right: 10px;
  top: 8px;
  align-items: center;
  justify-content: center;
}

.service-form .service-logo {
  background-repeat: no-repeat;
  background-size: cover;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}

.user-dashboard .service-confirmation table {
  font-size: 12px;
}

.service-confirmation th {
  color: #a0a0a0;
  font-weight: 100;
  padding: 15px 30px 0px 0px;
}

.service-confirmation td {
  color: #6a6a6a;
  padding: 15px 30px 0px 0px;
  font-weight: 500;
}

.service-confirmation textarea {
  border: 1px solid #e6e6e6;
  color: #a0a0a0;
}

.service-confirmation .cancel .btn {
  background-color: transparent;
  border: 1px solid #4965d0;
  border-radius: 4px;
  color: #a0a0a0;
  margin-right: 30px;
}

.service-confirmation .continue .btn {
  background-color: #4d68c9;
  border: none;
  border-radius: 4px;
  padding-inline: 40px;
}

.service-form small {
  color: #db1138;
  font-size: 10px;
}

.airtime-trans-details {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.airtime-trans-details .info {
  display: flex;
  gap: 20px;
  font-size: 11px;
  font-weight: 100;
}

.airtime-trans-details .info .info-label {
  width: 50px;
  text-align: end;
}

.airtime-trans-details .info .bold {
  font-weight: 500;
  color: #6a6a6a;
}

.airtime-trans-details .info img {
  height: 35px;
  width: 35px;
  border-radius: 50%;
}

.user-dashboard .agent-list-btn {
  border: none;
  background-color: transparent;
  padding: 10px;
  color: #3483f5;
}

.user-dashboard .date-filter {
  display: flex;
  align-items: center;
}

.user-dashboard .date-filter p {
  margin-bottom: 0;
  margin-right: 5px;
  font-size: 10px;
}

.user-dashboard .filter-btn {
  background-color: transparent;
  color: #060d27;
  border: 1px solid #060d27;
  height: 44px;
  padding-inline: 20px;
  margin-left: 10px;
}

.user-dashboard .filter-btn:hover {
  color: #060d27;
}

.user-dashboard .card-summary {
  background-color: #ffffff;
  display: flex;
  padding: 20px;
  border-radius: 7px;
  border: 1px solid #e6e6e6;
}

.user-dashboard .summary-icon {
  margin-right: auto;
  margin-left: 0;
}

.user-dashboard .summary-icon img {
  width: 50px;
}

.user-dashboard .card-summary .data {
  text-align: end;
  font-size: 10px;
}

.user-dashboard .card-summary .data .amount span {
  font-weight: 600;
  margin-left: 2px;
}

.user-dashboard .card-summary .data .amount {
  font-size: 18px;
  letter-spacing: 0.1px;
  color: #000000;
  margin-bottom: 0;
}

.user-dashboard .card-summary .trans-summary-count {
  font-size: 12px;
}

.user-dashboard .card-summary .trans-summary-count span {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/view/user-dashboard/Home.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,MAAM;EACN,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".user-dashboard {\n  background-color: #f8fafb;\n  height: 100%;\n}\n\n.user-dashboard .sidebar {\n  top: 0;\n  padding: 0;\n  width: 16%;\n}\n\n.user-dashboard .logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.user-account {\n  padding: 15px;\n  border-bottom: 1px solid #e5e4e4;\n  opacity: 1;\n}\n\n.user-dashboard .user-card {\n  background: #f8fafb 0% 0% no-repeat padding-box;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  opacity: 1;\n  padding: 5px;\n}\n\n.user-dashboard .user-profile {\n  display: flex;\n  gap: 5px;\n  color: #a0a0a0;\n}\n\n.user-profile .about-user {\n  padding-top: 4px;\n  font-size: 10px;\n}\n\n.user-profile .about-user h1 {\n  font-weight: 600;\n  color: #000000;\n  font-size: 12px;\n  margin-bottom: 0;\n}\n\n.user-profile .about-user p {\n  font-weight: 100;\n  margin-bottom: 4px;\n}\n\n.user-profile .about-user span {\n  margin-left: 5px;\n  color: #3383f4;\n}\n\n.user-dashboard .user-card {\n  margin-top: 10px;\n}\n\n.user-card p {\n  color: #a0a0a0;\n  font-size: 10px;\n  margin-bottom: 0;\n}\n\n.user-card span {\n  font-size: 14px;\n  letter-spacing: 3.5px;\n  color: #000000;\n  margin-left: 4px;\n  font-weight: 500;\n}\n\n.user-profile .avatar {\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n}\n\n.user-dashboard .tier {\n  margin-top: 10px;\n}\n\n.user-dashboard h2 {\n  font-size: 10px;\n  color: #000000;\n  letter-spacing: 0.63px;\n  margin-bottom: 4px;\n}\n\n.user-dashboard h3 {\n  letter-spacing: 0.63px;\n  color: #838383;\n  font-size: 10px;\n}\n\n.user-dashboard .progress {\n  height: 6px;\n}\n\n.user-dashboard .progress-bar {\n  border-radius: 5px;\n}\n\n.user-dashboard .balance {\n  margin-top: 18px;\n}\n\n.user-dashboard .balance h3 {\n  color: #a0a0a0;\n  margin-bottom: 0;\n}\n\n.user-dashboard .balance p {\n  color: #000000;\n  font-weight: 500;\n  font-size: 12px;\n  letter-spacing: 3.5px;\n}\n\n/* .user-dashboard .nav {\n  padding-bottom: 30px;\n  border-bottom: 1px solid #060d27;\n} */\n\n.nav-links {\n  padding: 25px 15px;\n}\n\n.nav-link img {\n  height: 15px;\n  width: 15px;\n}\n\n.user-dashboard .nav-item {\n  padding: 7px 0;\n  cursor: pointer;\n  border-bottom: 1px solid #e5e4e4;\n}\n\n.user-dashboard .active {\n  background-color: #e8edff;\n  border-right: 3px solid #060d27;\n}\n\n.user-dashboard .nav-link {\n  letter-spacing: 1px;\n  color: #a0a0a0;\n  margin-left: 10px;\n}\n\n.user-dashboard .active-link {\n  color: #000000;\n  font-weight: 500;\n}\n\n.user-dashboard .sign-out {\n  margin-top: 20px;\n}\n\n.sign-out a {\n  color: #b1580b;\n  font-size: 12px;\n  font-weight: 100;\n  text-decoration: none;\n}\n\n.sign-out img {\n  height: 20px;\n  width: 20px;\n  margin-right: 10px;\n}\n\n.user-dashboard .btn {\n  box-shadow: none;\n}\n\n.user-dashboard main {\n  margin-left: 16.3%;\n  padding: 15px;\n}\n\n.user-dashboard .wallet-summary {\n  background-color: #060d27;\n  border-radius: 15px;\n  padding: 25px 15px;\n}\n\n.user-dashboard .wallet-summary .btn {\n  background-color: #242e4a;\n  color: #ffffff;\n  width: 100%;\n  padding: 10px;\n  border: none;\n  letter-spacing: 1.13px;\n}\n\n.user-dashboard .wallet-summary .hide-data {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.user-dashboard .wallet-summary .hide-data img {\n  height: 15px;\n}\n\n.user-dashboard .wallet-summary .hide-data {\n  cursor: pointer;\n}\n\n.user-dashboard .wallet-summary span {\n  font-size: 14px;\n  letter-spacing: 3.5px;\n  color: #bccfff;\n  margin-left: 4px;\n  font-weight: 500;\n}\n\n.active-icon {\n  filter: brightness(0.1);\n}\n\n.user-dashboard .wallet-summary p {\n  font-size: 10px;\n  letter-spacing: 0.81px;\n  color: #b4b4b4;\n}\n\n.user-dashboard .available-balance h1 {\n  font-size: 10px;\n  letter-spacing: 0.81px;\n  color: #b4b4b4;\n  margin-bottom: 12px;\n}\n\n.user-dashboard .available-balance p {\n  letter-spacing: 0px;\n  color: #ffffff;\n  font-family: \"OCR\";\n  font-size: 20px;\n  margin-bottom: 8px;\n}\n\n.user-dashboard .available-balance sup {\n  top: -1.5em;\n  font-size: 14px;\n}\n\n.user-dashboard .vas-services {\n  cursor: pointer;\n}\n\n.user-dashboard .bill-payment {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 15px;\n  padding: 12px;\n  height: 95px;\n  /* width: 270px; */\n}\n\n.user-dashboard .bill-payment img {\n  height: 45px;\n  width: 45px;\n}\n\n.user-dashboard .bill-payment h1 {\n  font-size: 16px;\n  color: #586684;\n}\n\n.user-dashboard .bill-payment p {\n  margin-bottom: 0;\n  font-size: 8px;\n  color: #a0a0a0;\n  text-transform: uppercase;\n}\n\n.bill-payment .arrow {\n  height: 10px !important;\n}\n\n.bill-payment .services {\n  margin-right: auto;\n  margin-left: 6px;\n}\n\n.become-an-agent {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 20px 40px;\n  height: 100px;\n  background-color: #faf1d6;\n  border-radius: 15px;\n}\n\n.become-an-agent .text {\n  margin-right: auto;\n  position: relative;\n}\n\n.become-an-agent .text h4 {\n  margin-right: auto;\n  font-size: 28px;\n  font-weight: 600;\n  color: #3358a9;\n}\n\n.become-an-agent .text .desc {\n  position: absolute;\n  color: #eebd46;\n  top: 30px;\n  left: 90px;\n  width: 250px;\n  font-weight: 500;\n}\n\n.become-an-agent .spout-logo {\n  height: 60px;\n}\n\n.become-an-agent .display-image {\n  position: absolute;\n  right: 15%;\n  top: 5px;\n}\n\n.become-an-agent .display-image img {\n  height: 130px;\n}\n\n.user-dashboard .table-heading {\n  display: flex;\n}\n\n.user-dashboard .table-heading h5 {\n  margin-right: auto;\n  font-size: 16px;\n  letter-spacing: 6px;\n  color: #060d27;\n  margin-bottom: 15px;\n}\n\n.user-dashboard .table-heading a {\n  letter-spacing: 0.72px;\n  color: #3383f4;\n  font-weight: 100;\n  text-decoration: none;\n  font-size: 12px;\n}\n\n.user-dashboard .table-responsive {\n  background-color: #ffffff;\n}\n\n.user-dashboard .services h6 {\n  color: #a7a7a7;\n  font-size: 12px;\n  font-weight: 100;\n}\n\n.user-dashboard .service-form {\n  border-right: 1px solid #a7a7a7;\n  border-left: 2px solid #a7a7a7;\n  padding-inline: 15px;\n  padding-bottom: 40px;\n}\n\n.user-dashboard .service-type ul {\n  list-style: none;\n  margin-top: 30px;\n  padding: 0;\n  color: #a0a0a0;\n  font-size: 12px;\n}\n\n.user-dashboard .icon-service {\n  height: 25px;\n  width: 25px;\n  margin-right: 10px;\n}\n\n.user-dashboard .service-type li {\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n\n.service-type .active-service {\n  color: #2300e5;\n}\n\n.user-dashboard .service-form form {\n  margin-top: 30px;\n  padding-right: 30px;\n}\n\n.services .disabled {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.service-form .grouped-input {\n  position: relative;\n  /* background-color: transparent; */\n  border-radius: 4px;\n  padding: 2px 8px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  font-size: 12px;\n  font-weight: 100;\n}\n\n.service-form .default {\n  border: 1px solid #097ffa;\n}\n\n.service-form .error {\n  border: 1px solid #e86880;\n}\n.service-form label {\n  position: absolute;\n}\n\n.service-form .form-control {\n  border: none;\n  height: 36px;\n  background-color: transparent;\n  box-shadow: none;\n  padding: 0;\n  padding-top: 14px;\n  font-weight: 500;\n  color: #000000;\n  text-transform: uppercase;\n}\n\n.service-form .continue {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.service-form .btn {\n  background-color: #4d68c9;\n  border: none;\n  border-radius: 4px;\n  padding-inline: 40px;\n}\n\n.service-form .select-icon {\n  display: flex;\n  gap: 5px;\n  position: absolute;\n  right: 10px;\n  top: 8px;\n  align-items: center;\n  justify-content: center;\n}\n\n.service-form .service-logo {\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n}\n\n.user-dashboard .service-confirmation table {\n  font-size: 12px;\n}\n\n.service-confirmation th {\n  color: #a0a0a0;\n  font-weight: 100;\n  padding: 15px 30px 0px 0px;\n}\n\n.service-confirmation td {\n  color: #6a6a6a;\n  padding: 15px 30px 0px 0px;\n  font-weight: 500;\n}\n\n.service-confirmation textarea {\n  border: 1px solid #e6e6e6;\n  color: #a0a0a0;\n}\n\n.service-confirmation .cancel .btn {\n  background-color: transparent;\n  border: 1px solid #4965d0;\n  border-radius: 4px;\n  color: #a0a0a0;\n  margin-right: 30px;\n}\n\n.service-confirmation .continue .btn {\n  background-color: #4d68c9;\n  border: none;\n  border-radius: 4px;\n  padding-inline: 40px;\n}\n\n.service-form small {\n  color: #db1138;\n  font-size: 10px;\n}\n\n.airtime-trans-details {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.airtime-trans-details .info {\n  display: flex;\n  gap: 20px;\n  font-size: 11px;\n  font-weight: 100;\n}\n\n.airtime-trans-details .info .info-label {\n  width: 50px;\n  text-align: end;\n}\n\n.airtime-trans-details .info .bold {\n  font-weight: 500;\n  color: #6a6a6a;\n}\n\n.airtime-trans-details .info img {\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n}\n\n.user-dashboard .agent-list-btn {\n  border: none;\n  background-color: transparent;\n  padding: 10px;\n  color: #3483f5;\n}\n\n.user-dashboard .date-filter {\n  display: flex;\n  align-items: center;\n}\n\n.user-dashboard .date-filter p {\n  margin-bottom: 0;\n  margin-right: 5px;\n  font-size: 10px;\n}\n\n.user-dashboard .filter-btn {\n  background-color: transparent;\n  color: #060d27;\n  border: 1px solid #060d27;\n  height: 44px;\n  padding-inline: 20px;\n  margin-left: 10px;\n}\n\n.user-dashboard .filter-btn:hover {\n  color: #060d27;\n}\n\n.user-dashboard .card-summary {\n  background-color: #ffffff;\n  display: flex;\n  padding: 20px;\n  border-radius: 7px;\n  border: 1px solid #e6e6e6;\n}\n\n.user-dashboard .summary-icon {\n  margin-right: auto;\n  margin-left: 0;\n}\n\n.user-dashboard .summary-icon img {\n  width: 50px;\n}\n\n.user-dashboard .card-summary .data {\n  text-align: end;\n  font-size: 10px;\n}\n\n.user-dashboard .card-summary .data .amount span {\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n.user-dashboard .card-summary .data .amount {\n  font-size: 18px;\n  letter-spacing: 0.1px;\n  color: #000000;\n  margin-bottom: 0;\n}\n\n.user-dashboard .card-summary .trans-summary-count {\n  font-size: 12px;\n}\n\n.user-dashboard .card-summary .trans-summary-count span {\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
